import theme from '@styles/theme';
export default {
  showroomCard: {
    display: 'flex',
    width: '100%',
    flexDirection: ['column', 'column', 'column', 'column', 'row'],
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    pb: ['0', '0', '0', '0', '116px'],
    backgroundColor: theme.rawColors.beige500
  },
  galleryContainer: {
    position: 'relative',
    width: ['100%', '100%', '100%', '100%', '49.427083333vw'],
    height: ['100vw', '100vw', '100vw', '100vw', '37.0703125vw'],
    img: {
      objectFit: 'cover'
    },
    overflow: 'hidden',
    button: {
      position: 'absolute',
      left: 20,
      top: 20,
      zIndex: theme.zIndex.documentUp,
      svg: {
        mr: 10,
        path: {
          fill: theme.rawColors.neutralWhite
        }
      },
      ':hover': {
        color: theme.rawColors.neutralWhite,
        svg: {
          fill: theme.rawColors.neutralWhite,
          path: {
            fill: theme.rawColors.neutralWhite
          }
        }
      }
    },
    a: {
      position: 'absolute',
      left: 20,
      top: 20,
      zIndex: theme.zIndex.documentUp,
      textDecoration: 'none',
      svg: {
        mr: 10,
        path: {
          fill: theme.rawColors.neutralWhite
        }
      },
      ':hover': {
        color: theme.rawColors.neutralWhite,
        svg: {
          fill: theme.rawColors.neutralWhite,
          path: {
            fill: theme.rawColors.neutralWhite
          }
        }
      }
    }
  },
  cardContainer: {
    position: 'relative',
    width: ['100%', '100%', '100%', '100%', '49.427083333vw'],
    height: 'auto',
    mt: ['64px', '64px', '64px', 0],
    padding: ['0 40px 64px', '0 40px 64px', '80px', '80px', '116px 116px 0 116px'],
    p: {
      mt: ['40px']
    },
    buttons: (singleButton = false) => {
      const buttonLikeStyles = {
        width: !singleButton ? ['100%', 'calc(50% - 20px)', 'calc(50% - 20px)', 'calc(50% - 20px)', '240px', 'calc(50% - 20px)'] : ['100%', '100%', '100%', '100%', '240px', '100%'],
        mb: ['16px', 0, 0, 0, '16px', 0],
        overflow: 'hidden',
        '&:first-of-type': {
          mr: [0, '40px', '40px', '40px', 0, '40px']
        },
        div: {
          width: 'auto',
          ml: '8px',
          mt: '2px'
        },
        ':hover': {
          '.icon': {
            color: theme.rawColors.neutralWhite,
            svg: {
              color: theme.rawColors.neutralWhite,
              fill: theme.rawColors.neutralWhite,
              path: {
                fill: theme.rawColors.neutralWhite
              }
            }
          }
        }
      };
      return {
        display: 'flex',
        flexDirection: ['column', 'row', 'row', 'row', 'column', 'row'],
        justifyContent: 'flex-start',
        alignItems: ['start', 'center', 'center', 'center', 'start', 'center'],
        mt: !singleButton ? '40px' : [0, '16px', '16px', '16px', 0, '16px'],
        button: buttonLikeStyles,
        a: {
          ...buttonLikeStyles,
          textDecoration: 'none'
        }
      };
    },
    styledMainHeading: {
      display: 'block',
      width: '100%',
      fontFamily: theme.fonts.uniform,
      fontSize: theme.fontSizes.h3,
      letterSpacing: theme.letterSpacings.normal,
      mt: 24,
      textTransform: 'none'
    },
    details: {
      font: theme.fonts.uniform,
      p: {
        font: theme.fonts.uniform,
        fontSize: theme.fontSizes.h3,
        mt: 0,
        mb: 40
      },
      span: {
        width: '100%'
      },
      'span, a': {
        display: 'block',
        fontSize: theme.fontSizes.text,
        color: theme.rawColors.darkGrey700,
        mb: '8px'
      }
    },
    openingHours: {
      span: {
        mb: '0px'
      }
    },
    emailLink: {
      a: {
        textDecoration: 'underline'
      }
    },
    phoneLink: {
      a: {
        textDecoration: 'none'
      }
    }
  }
};